import {connect} from "react-redux";
import * as InfoActions from '../../../store/actions/infoActions';
import * as AuthActions from '../../../store/actions/authActions';
import AvatarModal from "../../../components/Dashboard/DashboardUser/AvatarModal";

const mapStateToProps = (state) => ({
    ...state.auth
});

const mapDispatchToProps = (dispatch) => ({
    uploadAvatar: (data, profileId, token) => {
        dispatch(AuthActions.uploadAvatar(data, profileId, token));
    },
    updateProfile: (profile, token) => {
        dispatch(InfoActions.updateProfile(profile, token));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AvatarModal);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardUser/AvatarModalContainer.js